import { COLORS } from './CatTripColors';

export const mainNavLinks = {
  mainCategory: {
    label: 'Beer Hub',
    to: '/categories/beer-hub'
  },
  subCategory: {
    'non-alcoholic': { label: 'Non-Alcoholic Beer', to: '/categories/beer-hub/non-alcoholic' },
    'malts-ices': { label: 'Malts & Ices', to: '/categories/beer-hub/malts-ices' },
    'american-classic': { label: 'American Classics', to: '/categories/beer-hub/american-classic' },
    'american-light': { label: 'American Lights', to: '/categories/beer-hub/american-light' },
    'american-balanced': { label: 'American Balanced Choices', to: '/categories/beer-hub/american-balanced' },
    imports: { label: 'Imports Styles', to: '/categories/beer-hub/imports' },
    'premium-favorites': { label: 'Premium Favorites', to: '/categories/beer-hub/premium-favorites' },
    'ipa-pale-ale': { label: 'IPA/Pale Ales', to: '/categories/beer-hub/ipa-pale-ale' },
    'craft-varieties': { label: 'Craft Varieties', to: '/categories/beer-hub/craft-varieties' },
    flavored: { label: 'Flavored Beer', to: '/categories/beer-hub/flavored' }
  }
};

export const subNavLinks = [
  { href: '#definition', text: 'Definition' },
  { href: '#sizing', text: 'Sizing' },
  { href: '#consumer-perceptions', text: 'Consumer Perceptions' },
  { href: '#wrap-up', text: 'Wrap Up' }
];

export const navColorSet = {
  'non-alcoholic': {
    anchorBarColor: COLORS.NON_ALC_YELLOW,
    anchorBarColorSecondary: COLORS.DARK_OVERLAY,
    textColor: COLORS.TEXT_BLACK
  },
  'malts-ices': {
    anchorBarColor: COLORS.MALT_ICE_YELLOW,
    anchorBarColorSecondary: COLORS.DARK_OVERLAY,
    textColor: COLORS.TEXT_BLACK
  },
  'american-classic': {
    anchorBarColor: COLORS.AM_CLASSIC_ORANGE,
    anchorBarColorSecondary: COLORS.DARK_OVERLAY,
    textColor: COLORS.TEXT_BLACK
  },
  'american-light': {
    anchorBarColor: COLORS.AM_LIGHT_ORANGE,
    anchorBarColorSecondary: COLORS.DARK_OVERLAY,
    textColor: COLORS.TEXT_BLACK
  },
  'american-balanced': {
    anchorBarColor: COLORS.AM_BALANCE_ORANGE,
    anchorBarColorSecondary: COLORS.DARK_OVERLAY,
    textColor: COLORS.TEXT_BLACK
  },
  imports: {
    anchorBarColor: COLORS.IMPORTS_ORANGE,
    anchorBarColorSecondary: COLORS.DARK_OVERLAY,
    textColor: COLORS.TEXT_WHITE
  },
  'premium-favorites': {
    anchorBarColor: COLORS.PREMIUM_FAVS_ORANGE,
    anchorBarColorSecondary: COLORS.DARK_OVERLAY,
    textColor: COLORS.TEXT_WHITE
  },
  'ipa-pale-ale': {
    anchorBarColor: COLORS.IPA_DRK_ORANGE,
    anchorBarColorSecondary: COLORS.DARK_OVERLAY,
    textColor: COLORS.TEXT_WHITE
  },
  'craft-varieties': {
    anchorBarColor: COLORS.CRAFT_OTHER_RED,
    anchorBarColorSecondary: COLORS.DARK_OVERLAY,
    textColor: COLORS.TEXT_WHITE
  },
  flavored: {
    anchorBarColor: COLORS.FLAVORED_DRK_RED,
    anchorBarColorSecondary: COLORS.DARK_OVERLAY,
    textColor: COLORS.TEXT_WHITE
  }
};
